// src/js/reducers/index.js
import * as types from "../constants/action-types";


function compare(a, b) {
    // Use toUpperCase() to ignore character casing
    const firstNameA = a.firstName ? a.firstName.toUpperCase() : '';
    const firstNameB = b.firstName ? b.firstName.toUpperCase() : '';
  
    let comparison = 0;
    if (firstNameA > firstNameB) {
      comparison = 1;
    } else if (firstNameA < firstNameB) {
      comparison = -1;
    }
    return comparison;
  }


export default function personnelReducer(state = {personnel: [], selected: {}, card: ''}, action) {
    switch (action.type) {
       
        case types.LOGOUT:
            return []
        case types.CREATE_PERSONNEL_SUCCESS:

            var result = Object.assign({}, state);
            result.personnel = [...result.personnel, Object.assign({}, action.personnel)];
            result.personnel = result.personnel.sort(compare);       
            result.selected = action.personnel;
            result.card = '';
            return result;

        case types.UPDATE_PERSONNEL_SUCCESS: 
            var result = Object.assign({}, state);
         
            result.personnel = [...result.personnel.filter(personnel => personnel.personnelId !== action.personnel.personnelId), 
                Object.assign({}, action.personnel)];
            result.personnel = result.personnel.sort(compare);   
            result.selected = action.personnel; 
            result.card = '';  
            return result;

        case types.GET_PERSONNEL_SUCCESS:          
            var result = Object.assign({}, state);
      
            result.personnel = [...result.personnel.filter(personnel => personnel.personnelId !== action.personnel.personnelId), 
                Object.assign({}, action.personnel)];
            result.personnel = result.personnel.sort(compare);   
            result.selected = action.personnel; 
            result.card = '';   
            return result;

        case types.LOAD_PERSONNEL_SUCCESS:
          console.log(action.personnel)
            var result = Object.assign({}, state);
            console.log(action.personnel)
            result.personnel = action.personnel.sort(compare);
            result.card = '';
            result.selected = {};
            return result;

        case types.LOAD_CARD_PERSONNEL_SUCCESS:

            var result = Object.assign({}, state);             
            result.card = action.personnel;
            result.selected = {};      
            return result;       

        case types.CLEAR_PERSONNEL_CARDREADER:
            var result = Object.assign({}, state);
        
            result.card = '';
            result.selected = {};
            return result;

        default:
            return state;
    };
};


